module.exports = __webpack_public_path__ + "static/image4-496466bb65d3d4edff527b303181aa69.jpg";